/**
 * Course component styles.
 */
import { Styles } from 'react-jss';

export default {
  courseDetails: {
    marginLeft: '20px',
    marginTop: '10px',
  },
  bookPanel: {
    marginLeft: '20px',
    marginTop: '6px',
    paddingBottom: '10px',
  },
} as Styles;
